import { useGT } from 'gt-react';
import type { OutlineCell, OutlineNode, ProcessStep } from '@erp/workbooks';
import type { WorkbookReferenceLabels } from './useWorkbookReferences';

/** An Instruction's first line as plain text, References replaced by names. */
export function instructionSummary(
  step: ProcessStep,
  references: WorkbookReferenceLabels,
) {
  return references.plainText(step.instructions.split('\n')[0] ?? '');
}

export function useExecutionLabel(references: WorkbookReferenceLabels) {
  const gt = useGT();
  function label(node: OutlineNode) {
    if (node.kind === 'instruction')
      return (
        node.step.title ||
        instructionSummary(node.step, references) ||
        gt('New instruction', { context: 'workbook unnamed process step' })
      );
    return gt('Build {name}', {
      context: 'workbook execution worksheet heading',
      name: references.name(node.itemId),
    });
  }
  return {
    label,
    /** A cell is titled by its first Instruction's title, else by its head. */
    cellTitle: (cell: OutlineCell) =>
      cell.instructions[0]?.step.title || label(cell.head),
  };
}
